import { useCallback, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { nanoid } from 'nanoid'

import { firebase } from '../../core/services'

import {
  ANALYTICS_EVENT_CATEGORIES,
  ANALYTICS_EVENTS,
} from '../../common/constants'
import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { DISHES_QUERY } from '../graphql/queries'
import { FETCH_DISHES } from '../redux/action-types'
import { cleanupDishes } from '../redux/actions'

const useDishesQuery = (
  {
    menuId,
    isDishTypeIgnored,
    certainty,
    hasErrors,
    menuTitleId,
    search,
    dishIds,
    tier,
    curatorId,
    qaId,
    isAvailableForWork,
    wasDoneInPreviousTwoWeeks,
    isNotChecked,
    dishTypeId,
    courseTypeId,
  } = {},
  { pageSize, currentPage } = {},
  taskStatus,
) => {
  const sessionId = useRef(nanoid())
  const dispatch = useDispatch()
  useCleanupRedux(cleanupDishes)

  const { isLoading, error, data } = useSelector(store => store.dishes.dishes)

  const refetch = useCallback(
    (filtersParam, paginationParam) => {
      firebase.logEvent(
        ANALYTICS_EVENTS.MENU_CURATOR_LOAD_DISHES
          .MENU_CURATOR_START_LOAD_DISHES,
        {
          sessionId: sessionId.current,
          ...filtersParam,
          ...paginationParam,
          eventCategory: ANALYTICS_EVENT_CATEGORIES.MENU_CURATOR_LOAD_DISHES,
        },
      )

      apolloService.query({
        query: DISHES_QUERY,
        variables: {
          filters: filtersParam,
          pagination: paginationParam,
        },
        dispatch,
        onSuccess: () =>
          firebase.logEvent(
            ANALYTICS_EVENTS.MENU_CURATOR_LOAD_DISHES
              .MENU_CURATOR_END_LOAD_DISHES,
            {
              sessionId: sessionId.current,
              ...filtersParam,
              ...paginationParam,
              eventCategory:
                ANALYTICS_EVENT_CATEGORIES.MENU_CURATOR_LOAD_DISHES,
            },
          ),
        action: FETCH_DISHES,
      })
    },
    [dispatch],
  )

  useEffect(() => {
    refetch(
      {
        menuId,
        isDishTypeIgnored,
        certainty,
        hasErrors,
        isAvailableForWork,
        wasDoneInPreviousTwoWeeks,
        isNotChecked,
        menuTitleId,
        search,
        dishIds,
        tier,
        curatorId,
        qaId,
        dishTypeId,
        courseTypeId,
      },
      { pageSize, currentPage },
    )
  }, [
    refetch,
    taskStatus,
    menuId,
    isDishTypeIgnored,
    certainty,
    hasErrors,
    isAvailableForWork,
    wasDoneInPreviousTwoWeeks,
    isNotChecked,
    menuTitleId,
    search,
    dishIds,
    pageSize,
    currentPage,
    tier,
    curatorId,
    qaId,
    dishTypeId,
    courseTypeId,
  ])

  return { isLoading, error, data }
}

export default useDishesQuery
